"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardStatsType = void 0;
/* eslint-disable require-jsdoc */
const constants_1 = require("../constants");
class CardStatsType {
    constructor(cardId) {
        this.score = 0.0;
        this.perfectScore = 0.0;
        this.maturityPoints = 0;
        this.difficulty = 0.0;
        this.answerTimes = 0;
        this.lastReviewDuration = 0;
        this.reviewAnswerChance = 3;
        this.firstChanceAttemptTimes = 0;
        this.secondChanceAttemptTimes = 0;
        this.thirdChanceAttemptTimes = 0;
        this.returnToAcquisitionTimes = 0;
        this.cardId = cardId;
    }
    static collectionPath(userId, moduleId) {
        // eslint-disable-next-line max-len
        return `${constants_1.constants.COLLECTION_PATH_STATS}/${userId}/${constants_1.constants.COLLECTION_PATH_MODULE_STATS}/${moduleId}/${constants_1.constants.COLLECTION_PATH_CARD_STATS}`;
    }
}
exports.CardStatsType = CardStatsType;
